<!-- HM alert - automatically shown based on data in alert store -->
<template>
  <div id="hmalert">
    <b-alert :show="show" :variant="type">{{message}}</b-alert>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'HMAlert',
  computed: {
    ...mapState('alert', ['type', 'message']),
    ...mapState('alert', {
      show(state) {
        return state.message != null;
      }
    })
  },
  watch: { // you have to use function syntax here, as warned in the docs
    message: function (newMsg, oldMsg) {
      if (newMsg && newMsg != oldMsg) {
        console.log('Alert: Scrolling to top');
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    }
  }
};
</script>
